import { escapeHtml } from "./utils.js";

// Balance position within each interview, and persist it in the design snapshot.
export function assignAlternativeOrder(tasks, random = Math.random) {
  const positions = tasks.map((_, index) => index % 2 === 0);
  for (let i = positions.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [positions[i], positions[j]] = [positions[j], positions[i]];
  }
  tasks.forEach((task, index) => {
    task.presentation_version = 2;
    task.display_order = positions[index] ? ["metro", "bus"] : ["bus", "metro"];
  });
}

export function orderedAlternatives(task) {
  // Existing interviews retain their original order.
  return (task.display_order || task.alternatives.map(item => item.id))
    .map(id => task.alternatives.find(item => item.id === id));
}

export function totalJourneyMinutes(alternative) {
  return alternative.attributes.filter(attribute => attribute.unit === "min" || attribute.id.endsWith("_min"))
    .reduce((total, attribute) => total + (Number(attribute.value) || 0), 0);
}

export function journeyStages(alternative) {
  const attributes = new Map(alternative.attributes.map(item => [item.id, item]));
  const lighting = attributes.get("walk_transfer_lighting")?.value;
  const lightingText = {
    dia: "durante o dia", noite_bem_iluminada: "à noite bem iluminada",
    noite_mal_iluminada: "à noite mal iluminada", 0: "à noite mal iluminada", 1: "à noite bem iluminada"
  }[lighting] || "";
  const stage = (id, title, icon, details = "") => ({ id, title, icon,
    time: `${attributes.get(id)?.value} min`, details, span: 1 });
  const stages = alternative.id === "bus" ? [
    stage("ivt_bus_min", "no ônibus", "bus"),
    stage("walk_dest_bus_min", "de caminhada até o destino", "walk")
  ] : [
    stage("ivt_bus1_min", "no ônibus até a integração", "bus"),
    stage("walk_transfer_min", "de caminhada até o metrô", "walk", lightingText),
    stage("wait_metro_min", "de espera pelo metrô", "clock",
      attributes.has("station_information") ? (Number(attributes.get("station_information").value) === 1 ? "com acesso fácil a informações da viagem" : "com acesso difícil a informações da viagem") : ""),
    stage("ivt_metro_min", "no metrô", "train",
      attributes.has("metro_crowding") ? (Number(attributes.get("metro_crowding").value) === 1 ? "lotado" : "com assentos disponíveis") : ""),
    stage("walk_dest_metro_min", "de caminhada até o destino", "walk")
  ];
  return stages.filter(stage => attributes.has(stage.id) && Number(attributes.get(stage.id).value) > 0);
}

export function renderScenarioCards(task, selectedId, iconSvg) {
  return orderedAlternatives(task).map((alternative, index) => `
    <button class="scenario-card ${selectedId === alternative.id ? "selected" : ""}" type="button"
      data-action="choose-alternative" data-alternative="${escapeHtml(alternative.id)}" aria-pressed="${selectedId === alternative.id}">
      <div class="scenario-title">
        <span class="mode-icon" aria-hidden="true">${iconSvg(alternative.id === "metro" ? "train" : "bus")}</span>
        <div><span class="scenario-label">Alternativa ${String.fromCharCode(65 + index)}</span><h3>${escapeHtml(alternative.label)}</h3></div>
        <span class="scenario-radio" aria-hidden="true"></span>
      </div>
      <div class="journey-stages">${journeyStages(alternative).map(stage => `
        <div class="journey-stage" data-stage="${stage.id}">
          <span class="attribute-icon" aria-hidden="true">${iconSvg(stage.icon)}</span>
          <span><strong>${escapeHtml(stage.time)}</strong> ${escapeHtml(stage.title)}${stage.details ? `, ${escapeHtml(stage.details)}` : ""}</span>
        </div>`).join("")}
        ${alternative.attributes.some(attribute => attribute.id === "has_stairs" && Number(attribute.value) === 1) ? `<div class="journey-stage stairs-note" data-stage="has_stairs"><svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24"><path d="M2 21h5v-5h5v-5h5V6h5" fill="none" stroke="currentColor" stroke-width="2"/></svg> Escada na estação</div>` : ""}
      </div>
      <div class="scenario-summary">

        ${alternative.id === "metro" ? `<span class="transfer-cost">Custo da transferência: R$ 0,00</span>` : ""}
        <span class="journey-total">Tempo total: ${totalJourneyMinutes(alternative)} min</span>
      </div>
    </button>`).join("");
}
